// extracted by mini-css-extract-plugin
module.exports = {"envBalloon":"EnvironmentIndicator_envBalloon__IpPqh","local":"EnvironmentIndicator_local__VCOuf","test":"EnvironmentIndicator_test__3Yzxg","stg":"EnvironmentIndicator_stg__3ZOIS"};